import React from 'react';
import { AdminLayout } from 'apps/sigma2-ui/src/components/AdminLayout';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { SimpleInput } from 'apps/sigma2-ui/src/components/ui/SimpleInput';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { SaveIndicator } from 'apps/sigma2-ui/src/components/SaveIndicator';
import { useDatabasesNewPage } from 'apps/sigma2-ui/src/data-wizard/lib/useDatabasesNewPage';
import { AdminBreadcrumbs } from 'apps/sigma2-ui/src/components/ui/AdminBreadcrumbs';

export const DatabasesNewPage = () => {
  const {
    databaseNameLabel,
    databaseName,
    setDatabaseName,
    submitButtonLabel,
    submitButtonDisabled,
    submitButtonBehavior,
    backButtonLabel,
    backButtonDisabled,
    backButtonBehavior,
    saveIndicatorStatus,
    organizationId,
  } = useDatabasesNewPage();

  return (
    <AdminLayout currentPage={'DatabasesNew'}>
      <AdminBreadcrumbs
        items={[
          { label: 'Home', to: '/admin' },
          { label: 'Organizations', to: '/organizations' },
          {
            label: 'Databases',
            to: `/organizations/${organizationId}/databases`,
          },
          {
            label: 'New Database',
            to: `/organizations/${organizationId}/databases/new`,
          },
        ]}
      />
      <Spacing size={'md'} direction={'vertical'}>
        <Paragraph>
          You can create a database here. Please provide a name.
        </Paragraph>

        <div>
          <SimpleInput
            label={databaseNameLabel}
            value={databaseName}
            onChange={setDatabaseName}
          />
        </div>

        <Spacing size={'md'} direction={'horizontal'}>
          <Spacing size="sm" direction="horizontal">
            <Button
              behavior={backButtonBehavior}
              text={backButtonLabel}
              disabled={backButtonDisabled}
            />

            <Button
              behavior={submitButtonBehavior}
              text={submitButtonLabel}
              disabled={submitButtonDisabled}
            />
          </Spacing>

          <SaveIndicator status={saveIndicatorStatus} />
        </Spacing>
      </Spacing>
    </AdminLayout>
  );
};
